import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NavigationHelper from 'layers/navigation/navigationHelper'
import { navigationEvent } from 'layers/navigation/store/operations'
import {
  operations as licenseOperations,
  selectors,
} from 'store/licenseManager'
import ExpiredLicensesNotification from './component'
import { RENEW_HREF } from './constants'
import { ExpiredLicensesNotificationWrapper } from './component.styles'

export const ExpiredLicensesNotificationContainer = () => {
  const dispatch = useDispatch()
  const {
    adminLicenses,
    adminNotificationsExist,
    nonAdminLicenses,
    nonAdminNotificationsExist,
  } = useSelector(selectors.selectExpiredLicenseNotifications)

  const handleAdminDismiss = () => {
    dispatch(licenseOperations.setNotificationAsRead('adminNotificationsExist'))
  }

  const handleAdminRenew = () => {
    dispatch(navigationEvent(RENEW_HREF, NavigationHelper.types.NEW_TAB))
  }

  const handleNonAdminDismiss = () => {
    dispatch(
      licenseOperations.setNotificationAsRead('nonAdminNotificationsExist'),
    )
  }

  return (
    <ExpiredLicensesNotificationWrapper>
      {adminLicenses.length > 0 && adminNotificationsExist && (
        <ExpiredLicensesNotification
          isAdmin
          licenses={adminLicenses}
          onDismiss={handleAdminDismiss}
          onRenew={handleAdminRenew}
        />
      )}
      {nonAdminLicenses.length > 0 && nonAdminNotificationsExist && (
        <ExpiredLicensesNotification
          licenses={nonAdminLicenses}
          onDismiss={handleNonAdminDismiss}
        />
      )}
    </ExpiredLicensesNotificationWrapper>
  )
}

export default ExpiredLicensesNotificationContainer
